import { Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Backdrop, Button, ButtonBase, Chip, CircularProgress, Grid, IconButton, List, ListItemButton, ListSubheader, Skeleton, ThemeProvider, ToggleButton, ToggleButtonGroup, createTheme, styled } from '@mui/material';
import * as XLSX from 'xlsx';
import ReactDOM from 'react-dom'; // Add this line to import ReactDOM
// import DataGrid from 'react-data-grid';
import { createRoot } from 'react-dom/client';
import { useRef } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import axios from 'axios';
import ExcelDisplay from './ExcelDisplay';

import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

import SessionExpiredModal from '../../../utils/SessionExpiredModal';

import SearchIcon from '@mui/icons-material/Search';

import {formatDatetime, PaginationNavigation} from '../../../utils/funtions'
import MessageModalModified from '../../../utils/MessageModalModified';
import PDFDisplay from './PDFDisplay';
import DocumentList from './DocumentList';
import FilterDocument from './FilterDocument';
// import 'jspreadsheet';
// import JSSpreadsheet from 'jspreadsheet';
// import 'jspreadsheet-ce/dist/jspreadsheet.css';
// import JSSpreadsheet from 'jspreadsheet-ce';

const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    borderRadius: '1vw',
    transition: '0.1s',
    '&:hover, &.Mui-focusVisible': {
      zIndex: 1,
      backgroundColor: 'rgb(255, 255, 255, 0.05)',
      '& .MuiImageBackdrop-root': {
        opacity: 0.15,
      },
      '& .MuiImageMarked-root': {
        opacity: 0,
      },
      '& .MuiTypography-root': {
        border: '4px solid currentColor',
      },
    },
  }));



function groupByClientIdAndDocumentType(documents) {
    // Using reduce to group the documents
    const grouped = documents.reduce((acc, curr) => {
        // Check if this client_id already exists in accumulator
        const existingGroup = acc.find(group => group.clientId === curr.client_id);

        if (!existingGroup) {

            // If group doesn't exist, create new group
            acc.push({
                clientId: curr.client_id,
                clientName: curr.client_name,
                clientABN: curr.rp_abn, // Using rp_abn (Reporting Party ABN) as clientABN
            });
        }

        return acc;
    }, []);

    return grouped;
}

function groupByDocumentType(documents) {
    // Using reduce to group the documents
    const grouped = documents.reduce((acc, curr) => {
        // Check if this client_id already exists in accumulator
        const existingGroup = acc.find(group => group.document_type === curr.document_type);

        if (!existingGroup) {

            // If group doesn't exist, create new group
            acc.push({
                document_type: curr.document_type
            });
        }

        return acc;
    }, []);

    return grouped;
}


function formatABN(abn) {

    if(abn == 'NOT PROVIDED'){
        return abn
    }

    // Remove any non-digit characters in case the input is not clean
    let str = abn.replace(/\D/g, '');

    // Check if the input is exactly 11 digits, if not, handle as needed
    if (str.length !== 11) {
        console.error("Invalid ABN: ABN must be exactly 11 digits");
        return null;
    }

    // Insert spaces to format as ABN
    return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
}

const TextButton = styled(Button)(({ theme }) => ({
    color: 'white',
    textTransform: 'none',
    padding: '0.5vw 0.75vw'
  }));


export default (props) => {
    const navigate = useNavigate();
    const auth = useAuth();

    const [isVersionDisplayReloading, setIsVersionDisplayReloading] = useState(false)

    const [excelDisplayShow, setExcelDisplayShow] = useState(false)

    const [pdfDisplayShow, setPdfDisplayShow] = useState(false)

    const [createWorkpaperShow, setCreateWorkpaperShow] = useState(false)

    const [reactivateSubscriptionShow, setReactivateSubscriptionShow] = useState(false)

    const [displayMode, setDisplayMode] = useState('folder')

    const [retrievedPeriods, setRetrievedPeriod] = useState([])

    const [transformedData, setTransformedData] = useState([])

    const [selectedGroup, setSelectedGroup] = useState({clientId: -1, clientName: '', clientAbn: '', documentTypes: []})


    // Table
    const [data, setData] = useState([]);

    const [rawData, setRawData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const [isSubscriptionActive, setIsSubscriptionActive] = useState(false)


    //Excel
    const [workbook, setWorkbook] = useState()

    const [excelRequest, setExcelRequest] = useState()

    const [timer, setTimer] = useState()

    const [isPDFLoading, setIsPDFLoading] = useState(false)


    // Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    const [filteredData, setFilteredData] = useState([]);

    const [selectedItems, setSelectedItems] = useState(new Array(filteredData.length).fill(false));
    const [selectAll, setSelectAll] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);

    const [itemsPerPage, setItemsPerPage] = useState(20)

    const [filterModalShow, setFilterModalShow]  = useState(false)

    const [selectedDocumentType, setSelectedDocumentType] = useState({type: '', items: []})

    const [selectedDocument, setSelectedDocument] = useState({filename: ''})

    const [clientList, setClientList] = useState([])

    const [docTypeList, setDocTypeList] = useState([])


   


    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [currentItems, setCurrentitems] = useState(filteredData.slice(indexOfFirstItem, indexOfLastItem))



    useEffect(() => {
      // When filters change, reset to page 1 and recalc visible items so the user always returns to the first page.
        setCurrentPage(1);
        let indexOfLastItem = 1 * itemsPerPage;
        let indexOfFirstItem = indexOfLastItem - itemsPerPage;
        setCurrentitems(filteredData.slice(indexOfFirstItem, indexOfLastItem));
    }, [filteredData]);


    useEffect(() => {
        // Calculate the items for the current page
        let indexOfLastItem = currentPage * itemsPerPage;
        let indexOfFirstItem = indexOfLastItem - itemsPerPage;
        setCurrentitems(filteredData.slice(indexOfFirstItem, indexOfLastItem))
    }, [currentPage]);



    // Popup
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [backdropOpen, setBackdropOpen] = React.useState(false);
    const handleBackdropClose = () => {
        setBackdropOpen(false);
    };
    const handleBackdropOpen = () => {
        setBackdropOpen(true);
    };

    const [reloadButtonDisabled, setReloadButtonDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [sessionExpired, setSessionExpired] = useState(false)

    function isOlderThanDays(dateString, days) {
        const inputDate = new Date(dateString);
        const now = new Date();

        // Difference in milliseconds
        const diffMs = now - inputDate;

        // Convert ms → days
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        return diffDays > days; // true if older than 7 days
    }

    async function reload(){
        // if(!reloadButtonDisabled){
        //     setCurrentPage(1)
            // setSelectedGroup({clientId: -1, clientName: '', clientAbn: '', startDate: '', endDate: '', version: -1})

                    setReloadButtonDisabled(true); // Disable the reload button
                    try{
                        let response = await fetch(`${window.origin}/api/dochero/documents`, {
                            headers: {
                                "Authorization": `Bearer ${auth.user?.access_token}`,
                                'Cache-Control': 'no-cache',
                                'If-None-Match': '0',
                            }
                        })

                        if(response.status === 403){
                            setSessionExpired(true)
                            return
                        }


                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        let data = await response.json()





                        console.log(data)

                        setRawData(data);

                        setData(data)

            

                        setFilteredData(data);

                        // console.log(data)
                    }catch(e){
                        console.log(e)

                    }


        }
        // }







    const handleDownload = (requestId, client_name, period) => {
        handleBackdropOpen()
        // Replace with your server's URL and correct endpoint
        const url = `${window.origin}/api/creator/export?requestid=${requestId}`; // Add the correct query parameter for the ID or other identifier you need

        fetch(url, {
            headers: {
                "Authorization": `Bearer ${auth.user?.access_token}`,
                'Cache-Control': 'no-cache',
                'If-None-Match': '0',
            }
        })
        .then((response) => {
            if(response.status === 403){
                setSessionExpired(true)
                throw new Error('Session expired');
            }
            // Check if the response is ok (status code 200)
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.blob(); // Convert the response to a blob
          })
        .then((blob) => {
            // Create a new URL for the blob object
            const objectUrl = URL.createObjectURL(blob);

            // Create a temporary anchor to trigger download
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = `Workpaper_${client_name}_${period}.xlsx`; // Name the file here
            document.body.appendChild(link);
            link.click(); // Trigger the download

            // Clean up the URL object and remove the temporary anchor
            URL.revokeObjectURL(objectUrl);
            document.body.removeChild(link);

            handleBackdropClose()
        })
        .catch((error) => {
            console.error('There has been a problem with your fetch operation:', error);
        });
      };


    // Filters all documents by client fields + document fields whenever searchTerm changes.
    useEffect(() => {
        const lower = searchTerm.toLowerCase();

        setFilteredData(
            data.filter(row =>
                (row.path && row.path.includes(searchTerm))
            )
        );
    }, [searchTerm, data]);


    useEffect(() => {
        // Calculate the items for the current page
        let indexOfLastItem = currentPage * itemsPerPage;
        let indexOfFirstItem = indexOfLastItem - itemsPerPage;
        setCurrentitems(transformedData.slice(indexOfFirstItem, indexOfLastItem))
    }, [currentPage]);

    const reloadWithLoading = async () => {
        setIsLoading(true); // Start showing the loading spinner
        handleBackdropOpen()
        await reload()
        setIsLoading(false); // Start showing the loading spinner
        handleBackdropClose()
    }

    useEffect( () => {
        if(displayMode == 'folder'){
            setItemsPerPage(12)
        }else{
            setItemsPerPage(8)
        }
        reloadWithLoading()

        // clearInterval(timer)

        reload()



    }, [displayMode])


    function filterDataHandler(start_date, end_date, clients, doc_types, period){

    if (start_date && start_date.reset) {
        setData(rawData);
        return;
    }

    console.log(start_date, end_date, clients, doc_types);

        let filteredRows = rawData.filter(doc => true)

        if(clients.length > 0){
            filteredRows = filteredRows.filter(doc => clients.includes(doc.client_id))
        }

        if(doc_types.length > 0){
            filteredRows = filteredRows.filter(doc => doc_types.includes(doc.document_type))
        }
        console.log(filteredRows)

        if(period == 'week'){
            filteredRows = filteredRows.filter(doc => !isOlderThanDays(doc.created_at, 7))
        }else if(period == 'month'){
            filteredRows = filteredRows.filter(doc => !isOlderThanDays(doc.created_at, 30))
        } else if(period == 'quarter'){
            filteredRows = filteredRows.filter(doc => !isOlderThanDays(doc.created_at, 120))
        }else if(period == 'year'){
            filteredRows = filteredRows.filter(doc => !isOlderThanDays(doc.created_at, 365))
        }


        setData(filteredRows)


    }







    return (
        <div className={props.imgClass} style={{ textAlign: 'center', position: 'relative', display: 'flex', flexDirection: 'row', width: '100%' }}>
            <SessionExpiredModal show={sessionExpired}/>
            <div className='mainContainer' style={{padding: 0, fontSize: '0.9vw', backgroundColor: 'rgb(254, 254, 255, 0.85)', border: '2px solid rgb(254, 254, 255, 0.3)', margin: '2vw', padding: '1vw', borderRadius: '2vw', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', lineHeight: '1vw', alignItems: 'center', padding: '0.5vw 0.5vw', paddingBottom: '1.5vw'}}>

                        <div style={{textAlign: 'left', marginBottom: '0.5vw',display: 'flex', flexDirection: 'row', width: '100%'}}>
                            <div style={{ backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '0.8vw', padding: '0.5vw', paddingLeft: '1vw', width: '15vw', color: 'rgb(0, 15, 30, 0.7)'}}>
                                        <ThemeProvider theme={darkTheme}>


                                                        <SearchIcon style={{fontSize: '1vw'}}/>
                                                </ThemeProvider>

                                                <Form.Control
                                                    id="client-search-bar"
                                                    style={{
                                                        display: 'inline',  backgroundColor: 'rgba(255,255,255,0)', padding: 0, paddingLeft: '0.5vw',
                                                        border: '1px solid rgb(254, 254, 255, 0)', borderRadius: '6px', fontSize: '0.9vw', maxWidth: '50%', marginLeft:'0' , fontWeight: '200'
                                                    }}
                                                    className='shadow-none'
                                                    type="text"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={e => setSearchTerm(e.target.value)}
                                                />
                                    </div>

                                    <div style={{flex: 1, textAlign: 'right', paddingLeft: '1vw', paddingRight: '0'}}>
                                <OverlayTrigger
                                    key={'top-submit'}
                                    placement={'top'}
                                    overlay={
                                        <Tooltip id={`tooltip-submit`}>
                                            Filter
                                        </Tooltip>
                                    }
                                    >
                                        <TextButton id="create-new-workpaper" variant='text' style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw',cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', marginLeft: '1vw'}} onClick={() => {setFilterModalShow(true)}}>
                                            <FilterAltOutlinedIcon  style={{fontSize: '0.9vw', width: '0.95vw', height: '0.95vw'}}/>
                                        </TextButton>

                                </OverlayTrigger>
                            </div>
                            </div>

                </div>


                <DocumentList setPdfDisplayShow={setPdfDisplayShow} setSelectedDocument={setSelectedDocument} setSelectedGroup={setSelectedGroup} filteredData={filteredData} isLoading={isLoading} />

            </div>
            <FilterDocument show={filterModalShow} onHide={() => {setFilterModalShow(false)}} clientList={clientList} docTypeList={docTypeList} filterDataHandler={filterDataHandler}/>
            <ExcelDisplay show={excelDisplayShow} workbook={workbook} onHide={()  => {setExcelDisplayShow(false)}} />
            <PDFDisplay show={pdfDisplayShow} onHide={()  => {setPdfDisplayShow(false)}} selectedDocument={selectedDocument} onShow={setPdfDisplayShow}/>
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropOpen}
                onClick={handleBackdropClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop> */}
        </div>
    );
}
